import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { currentVersion } from './app/appVersion';
import { environment } from './environments/environment';
import './global';
if (environment.production) {
  console.log('running radial client portal version ', currentVersion);
  console.log = () => {};
}
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
